import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../../app/store";

export enum ToastStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    INFO = "INFO",
}

export interface Toast {
    id: string;
    message: string;
    toastStatus: ToastStatus;
    duration: number;
    hasTimer: boolean;
}

export interface ToastState {
    toasts: Toast[];
}

const initialState: ToastState = {
    toasts: [],
};

export const toastNotificationSlice = createSlice({
    name: "toastNotification",
    initialState,
    reducers: {
        showToastNotification: (
            state,
            {payload}: PayloadAction<{ message: string; toastStatus?: ToastStatus; duration?: number }>
        ) => {
            const newToast: Toast = {
                id: `${Date.now()}-${Math.random()}`,
                message: payload.message,
                toastStatus: payload.toastStatus ?? ToastStatus.SUCCESS,
                duration: payload.duration ?? 3000,
                hasTimer: false
            };
            state.toasts.unshift(newToast);
        },
        showErrorToastNotification: (
            state,
            {payload}: PayloadAction<{ message: string; duration?: number }>
        ) => {
            const newToast: Toast = {
                id: `${Date.now()}-${Math.random()}`,
                message: payload.message,
                toastStatus: ToastStatus.ERROR,
                duration: payload.duration ?? 3000,
                hasTimer: false
            };
            state.toasts.unshift(newToast);
        },
        showSuccessToastNotification: (
            state,
            {payload}: PayloadAction<{ message: string; duration?: number }>
        ) => {
            const newToast: Toast = {
                id: `${Date.now()}-${Math.random()}`,
                message: payload.message,
                toastStatus: ToastStatus.SUCCESS,
                duration: payload.duration ?? 3000,
                hasTimer: false
            };
            state.toasts.unshift(newToast);
        },
        showInfoToastNotification: (
            state,
            {payload}: PayloadAction<{ message: string; duration?: number }>
        ) => {
            const newToast: Toast = {
                id: `${Date.now()}-${Math.random()}`,
                message: payload.message,
                toastStatus: ToastStatus.INFO,
                duration: payload.duration ?? 3000,
                hasTimer: false
            };
            state.toasts.unshift(newToast);
        },
        showCopiedSuccessfullyToastNotification: (
            state,
            {payload}: PayloadAction<{ fieldName?: string; duration?: number } | undefined>
        ) => {
            const newToast: Toast = {
                id: `${Date.now()}-${Math.random()}`,
                message: payload?.fieldName ? `${payload.fieldName} Copied Successfully` : "Copied Successfully",
                toastStatus: ToastStatus.SUCCESS,
                duration: payload?.duration ?? 3000,
                hasTimer: false
            };
            state.toasts.unshift(newToast); // Add new toast at the beginning
        },
        hideToastNotification: (state, action: PayloadAction<string>) => {
            state.toasts = state.toasts.filter((toast) => toast.id !== action.payload);
        },
    },
});

export const {
    showToastNotification,
    showErrorToastNotification,
    showSuccessToastNotification,
    showInfoToastNotification,
    showCopiedSuccessfullyToastNotification,
    hideToastNotification
} = toastNotificationSlice.actions;

export const selectToast = (state: RootState): Toast[] => state.toastNotification.toasts;
